import qs from 'qs';

export interface IQuery {
  sequenceNo: string;
  matterId: string;
  mallId?: string;
  matterType?: string;
  viewId: string;
  config: any;
  orderId?: string;
  preview?: boolean;
  [key: string]: any;
}

/** 采用了hash路由，兼容两个query的情况 */
export default function handleMultipleQuery(): IQuery {
  const locationStr = location.href.toString();
  const querySections = locationStr.split('?');
  let query: object = {};
  for (let i = 1; i < querySections.length; i += 1) {
    const qSection = querySections[i];
    if (qSection) {
      // 剔除query中的hash
      const q = qs.parse(qSection.split('#')[0]);
      query = {
        ...query,
        ...q,
        useDetailNew: true,
      };
    }
  }
  return query as IQuery;
}

export function genUrlSearch(obj: any) {
  let search: any[] = [];
  Object.keys(obj).forEach((key) => {
    if (obj[key]) {
      search.push(`${key}=${obj[key]}`);
    }
  });
  return search.join('&');
}
